import React, { FunctionComponent } from 'react';
import { Histories } from '../../../types/personShow';
import { PersonShowModal } from '../../organisms/personShowModal';

type Props = {
  personId: number;
  isPc: boolean;
  state: Histories & {
    isModal: boolean;
    type: 'favorites' | 'entries' | 'scouts';
  };
  handleOpenModal: (target: string) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  personId,
  isPc,
  state,
  handleOpenModal,
}) => {
  const isDisabled = state.favoritesCounts === 0 && state.entriesCounts === 0 && state.scoutsCounts === 0;

  return (
    <>
      <div className={`person__show__main__alert__scout ${isDisabled ? 'disabled' : ''}`}>
        <p className="person__show__main__alert__scout--title">この求職者に関する履歴</p>
        <div className="person__show__main__alert__scout--text">
          {(['favorites', 'scouts', 'entries'] as const).map((type, index) => (
            <React.Fragment key={type}>
              {index > 0 && <span>/</span>}
              <span
                onClick={() => handleOpenModal(type)}
                className={`item ${
                  (type === 'favorites' && state.favoritesCounts === 0) ||
                  (type === 'scouts' && state.scoutsCounts === 0) ||
                  (type === 'entries' && state.entriesCounts === 0)
                    ? 'disabled'
                    : ''
                }`}
              >
                {type === 'favorites' ? '求人保存' : type === 'scouts' ? 'スカウト' : '応募'}
                {type === 'favorites'
                  ? state.favoritesCounts
                  : type === 'scouts'
                  ? state.scoutsCounts
                  : state.entriesCounts}
                件
              </span>
            </React.Fragment>
          ))}
        </div>
      </div>
      <PersonShowModal
        isPc={isPc}
        handleOpenModal={handleOpenModal}
        title="履歴一覧"
        target="scoutList"
        isModal={state.isModal}
        personId={personId}
        scouts={state.scouts}
        entries={state.entries}
        favorites={state.favorites}
        favoritesCounts={state.favoritesCounts}
        entriesCounts={state.entriesCounts}
        scoutsCounts={state.scoutsCounts}
        type={state.type}
      />
    </>
  );
};
